module.exports = __webpack_public_path__ + "img/p2.3948951b.png";